export const TREATMENT_NAME_ID_MAP = {
  'Accept': 1,
  'Avoid': 2,
  'Mitigate': 3,
  'Transfer': 4
}

export const TREATMENT_ID_NAME_MAP = {
  0: 'No Treatment Type',
  1: 'Accept',
  2: 'Avoid',
  3: 'Mitigate',
  4: 'Transfer'
}